import { cn } from '../../lib/utils';

interface ProgressProps {
  value: number;
  max: number;
  className?: string;
  /** Rendered next to the bar, e.g. "34 von 50 · 68 %". */
  label?: string;
}

export function Progress({ value, max, className, label }: ProgressProps) {
  const percent = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label ? (
        <div className="flex items-baseline justify-between text-xs text-muted">
          <span>{label}</span>
          <span className="font-display text-sm text-foreground">{percent} %</span>
        </div>
      ) : null}
      <div
        className="h-2 overflow-hidden rounded-full bg-surface-raised"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-label={label}
      >
        <div
          className="h-full rounded-full bg-accent transition-[width] duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
